import AddIngredientModal from './add_ingredient_modal'

export default AddIngredientModal